export default "__VITE_ASSET__DUKLIzgU__"